import ScheduledTransactionEditDialog from './ScheduledTransactionEditDialog';

export default ScheduledTransactionEditDialog;
